import React from 'react';

import logo from 'assets/img/it-stock-logo.png';

export default function ItStockLogo(props) {
  return (
    <img {...props} src={logo} alt="IT Stock" width={20} height={20} />
  );
}
